<div class="line-container">
    <ul class="line-colours">
        <li class="one left"></li>
        <li class="two left"></li>
        <li class="three left"></li>
    </ul>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">

    <div class="container">
        <!-- <div>
            <a class="navbar-brand" [routerLink]="['/home']">
                <img src="./assets/img/logo_tenaris.png" alt="Tenaris">
            </a>
        </div> -->
        <a class="navbar-brand" [routerLink]="['/home']">
                <img src="./assets/img/logo_tenaris.png" alt="Tenaris">
            </a>
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button> -->
        <div class="collapse navbar-collapse d-flex justify-content-end" id="navbarNavDropdown">
            <ul class="nav navbar-nav ml-auto ">
                <li class="nav-item pr-4">
                    <a (click)="userClick($event)" class="nav-link">{{currentUser}}</a>
                </li>
                <li *ngIf="locations.length === 1 && currentLocation" class="nav-item pr-4">
                    <a class="nav-link">{{currentLocation.LocationName}}</a>
                </li>
                <li class="nav-item dropdown" *ngIf="showMenuLocations()">
                    <a class="nav-link dropdown-toggle" href="#" role="button" id="navbarDropdownMenuLink"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{currentLocation.LocationName}} ({{currentLocation.RoleName}})
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li *ngFor="let loc of locations">
                            <a href="#" [ngClass]="{'selected': loc.Selected}" class="dropdown-item"
                                (click)="changeProfile(loc)" href="javascript:void(0)">{{loc.LocationName}}
                                ({{loc.RoleName}})</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" id="navbarDropdownMenuLink"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        MENU
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li>
                            <a class="dropdown-item" (click)="logout($event)" href="#">{{'login.logout' |
                                translate}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>